<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Approve Proposed Products</p>
      </header>
      <section class="modal-card-body">
        <p class="pa-xl has-text-grey has-text-centered">
          You are about to approve <b>{{ this.proposals.length }}</b> {{ (this.proposals.length === 1) ? "proposal" :
          "proposals" }}.
          Once approved, the proposals will move forward in the workflow and cannot be edited.
          Are you sure you want to continue?
        </p>
      </section>
      <footer class="modal-card-foot space-between">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button type="is-primary" :disabled="saving" :loading="saving" @click="approveProposal">Approve</b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters(['app', 'context'])
  },
  data () {
    return {
      saving: false
    }
  },
  methods: {
    approveProposal () {
      console.log('====to be implemented')
    }
  },
  mounted () {
  },
  props: {
    proposals: {
      type: Array,
      required: true
    }
  }
}
</script>
